<template>
  <div>
    <div>
      <div>
        <div style="padding-top: 40px">
          <p class="navadno-besedilo">
            V tem razdelku najdete pregled svojih naročnin in priključkov.
            <span style="display: block">
              Da bo naše poslovanje z vami čim bolj učinkovito, vas prosimo, da preverite svoje kontaktne podatke in
              jih po potrebi posodobite.
            </span>
          </p>
          <p>
            Naročniki T-2 storitev lahko omogočite tudi soupravljanje naročnine.
            Več informacij najdete v zavihku
            <a href="/MojT2/UporabnikiInPravice" class="primarna-barva" style="cursor: pointer">
              Uporabniki in pravice</a>.
          </p>
        </div>
        <div style="padding-top: 30px"/>
        <p class="open-sans-20pt">
          Moje naročnine
        </p>
      </div>
      <div class="hidden-xs" v-if="narocnine.length > 0">
        <el-table :data="narocnine"
                  empty-text="Nimate povezanih naročnin"
                  style="padding-top: 20px">
          <el-table-column prop="id_stranka_sap" label="Številka kupca" min-width="50px"/>
          <el-table-column prop="naziv" label="Naročnik" min-width="60px"/>
          <el-table-column label="Naslov naročnika" min-width="100px">
            <template slot-scope="scope">
              {{ scope.row.naslov }}, {{ scope.row.kraj }}
            </template>
          </el-table-column>
          <el-table-column v-if="samoEnaNarocninaPrikaz">
            <template slot-scope="scope">
              <div class="postavitev-povezave manjsi-odmik">
                <a class="el-button okvir-povezave tekst-povezave el-button--default" style="cursor: pointer;"
                   @click="IzbiraStrankeZaPregledPrikljuckov(scope.row.id_stranka, true)">
                  PRIKAŽI PRIKLJUČKE
                </a>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="right" width="50px">
            <template slot-scope="scope">
              <div>
                <a @click="OdstraniNarocnino(scope.row.id_stranka_sap)" style="cursor: pointer">
                  <img src="/static/img/Nastavitve/SpletnaPredstavitev\Icon-awesome-trash-alt.png">
                </a>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="visible-xs-block" v-if="narocnine.length > 0">
        <div>
          <el-table :data="narocnine"
                    style="padding-top: 20px"
                    v-if="prikazTabele === '1'"
                    :expand-row-keys="expandRowKeys"
                    :row-key="row => row.id_stranka"
                    empty-text="Nimate povezanih naročnin"
                    @expand-change="IzbiraVrsticeZaPrikazPodatkov">
            <el-table-column prop="id_stranka" label="ŠT. STRANKE"/>
            <el-table-column prop="naziv" label="NAROČNIK"/>
            <el-table-column type="expand">
              <template slot-scope="scope">
                <div style="padding-top: 20px; padding-bottom: 20px">
                  <p class="navadno-besedilo">
                    <b>
                      Naslov:
                    </b>
                    {{ scope.row.naslov }}
                  </p>
                  <p class="navadno-besedilo">
                    <b>
                      Kraj:
                    </b>
                    {{ scope.row.kraj }}
                  </p>
                  <div class="postavitev-povezave manjsi-odmik odmik-top-30">
                    <a class="el-button okvir-povezave tekst-povezave el-button--default"
                       style="cursor: pointer; padding-top: 10px"
                       @click="OdstraniNarocnino(scope.row.id_stranka_sap)">
                      ODSTRANI NAROČNINO
                      <img src="/static/img/Nastavitve/SpletnaPredstavitev\Icon-awesome-trash-alt.png">
                    </a>
                  </div>
                  <div class="postavitev-povezave odmik-top-10" v-if="samoEnaNarocninaPrikaz">
                    <a class="el-button okvir-povezave tekst-povezave el-button--default" style="cursor: pointer;"
                       @click="IzbiraStrankeZaPregledPrikljuckov(scope.row.id_stranka, true)">
                      PRIKAŽI PRIKLJUČKE
                    </a>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-table
            v-else
            empty-text="Nimate povezanih naročnin"
            :data="narocnine">
            <el-table-column>
              <template slot-scope="props">
                <p style="padding-top: 10px;">
                <span>
                  <b>
                    Številka kupca:
                  </b>
                </span>
                  {{ props.row.id_stranka_sap }}
                </p>
                <p>
                <span>
                  <b>
                    Naročnik:
                  </b>
                </span>
                  {{ props.row.naziv }}
                </p>
                <p>
                <span>
                  <b>
                    Naslov:
                  </b>
                </span>
                  {{ props.row.naslov }}
                </p>
                <p>
                <span>
                  <b>
                    Kraj:
                  </b>
                </span>
                  {{ props.row.kraj }}
                </p>
                <div class="odmiki-mobile">
                  <div class="postavitev-povezave">
                    <a class="el-button okvir-povezave tekst-povezave el-button--default"
                       style="cursor: pointer; padding-top: 10px"
                       @click="OdstraniNarocnino(props.row.id_stranka_sap)">
                      ODSTRANI NAROČNINO
                      <img src="/static/img/Nastavitve/SpletnaPredstavitev\Icon-awesome-trash-alt.png">
                    </a>
                  </div>
                  <div class="postavitev-povezave odmik-top-10" v-if="samoEnaNarocninaPrikaz">
                    <a class="el-button okvir-povezave tekst-povezave el-button--default" style="cursor: pointer;"
                       @click="IzbiraStrankeZaPregledPrikljuckov(props.row.id_stranka, true)">
                      PRIKAŽI PRIKLJUČKE
                    </a>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div ref="prikljuckiList">
      <div v-if="narocnine.length > 0 && this.izbranaStranka !== ''">
        <UporabniskiPodatki :seznamNarocnin="narocnine"
                            :izbranaStranka="izbranaStranka"
                            v-on:seznamPrikljuckov="PridobljenSeznamPrikljuckov"
                            v-on:odpriTabStoritve="NastaviTabStoritve"
                            :upostevanjSamoNosilnePrikljucke="false" />
        <UporabniskiPodatki :seznamNarocnin="narocnine"
                            :samoMobilni="true"
                            :izbranaStranka="izbranaStranka"
                            v-on:odpriTabStoritve="NastaviTabStoritve"
                            v-on:seznamPrikljuckov="PridobljenSeznamPrikljuckov"
                            :upostevanjSamoNosilnePrikljucke="false" />
        <div>
          <InfoKomponentaUporabniskiPodatki/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
  import {Input, Button, Collapse, CollapseItem, Col, MessageBox, Checkbox, CheckboxGroup} from 'element-ui'
  import ClientAgent from '../../../../../assets/js/clientAgent.js'
  import {MixinGetUserData} from '../../../../../assets/js/globalne_funkcije/PridobitevUporabniskihPodatkovGlobalno/PridobitevUporabniskihPodatkov'
  import UporabniskiPodatki from '../../MojT2/Pregledstoritev/UporabniskiPodatki'
  import InfoKomponentaUporabniskiPodatki from '../../MojT2/Pregledstoritev/InfoKomponentaUporabniskiPodatki.vue'

  export default {
    name: 'MojeNarocnine',
    mixins: [MixinGetUserData, PrikazVsebine],
    data () {
      return {
        clientAgent: null,
        formaOrientacija: 'left',
        mejnaSirina: 600,
        activeName: '0',
        expandRowKeys: [],
        samoEnaNarocninaPrikaz: true,
        seznamPrikljuckov: null
      }
    },
    components: {
      InfoKomponentaUporabniskiPodatki,
      UporabniskiPodatki,
      [Button.name]: Button,
      [Input.name]: Input,
      [Collapse.name]: Collapse,
      [CollapseItem.name]: CollapseItem,
      [Col.name]: Col,
      [Checkbox.name]: Checkbox,
      [CheckboxGroup.name]: CheckboxGroup
    },
    mounted () {
      this.clientAgent = new ClientAgent()
      this.$nextTick(function () {
        window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
        window.dispatchEvent(new Event('resize'))
      })
      this.SamoEnaNarocnina()
    },
    props: {
      izbranaStranka: '',
      narocnine: null
    },
    methods: {
      NastaviTabStoritve () {
        this.$emit('odpriTabStoritve')
      },
      PridobljenSeznamPrikljuckov (val) {
        this.seznamPrikljuckov = val
      },
      SamoEnaNarocnina () {
        if (this.narocnine !== null && this.narocnine.length === 1) {
          this.samoEnaNarocninaPrikaz = false
          for (let i = 0; i < this.narocnine.length; i++) {
            this.IzbiraStrankeZaPregledPrikljuckov(this.narocnine[i].id_stranka, null, false)
          }
        }
      },
      async IzbiraStrankeZaPregledPrikljuckov (idStranke, status, autoscroll = true) {
        this.$emit('osveziIzbiroStranke', idStranke, status)
        await new Promise(resolve => setTimeout(resolve, 500))
        const el = this.$refs.prikljuckiList
        if (autoscroll && el) {
          document.getElementById('mainContentId').scrollTop = el.offsetTop + 130
        }
      },
      IzbiraVrsticeZaPrikazPodatkov (row) {
        const id = row.id_stranka
        const lastId = this.expandRowKeys[0]
        this.expandRowKeys = id === lastId ? [] : [id]
      },
      OdstraniNarocnino (idStrankaSap) {
        MessageBox.confirm('Ali ste prepričani, da želite odstraniti naročnino?', {
          confirmButtonText: 'Da',
          cancelButtonText: 'Prekliči',
          confirmButtonClass: 'gumb-potrdi',
          cancelButtonClass: 'gumb-preklici',
          customClass: 'opozorilo-dialog'
        }).then(() => {
          let param = ['sap=' + idStrankaSap]
          this.clientAgent.postWsRequest(this,
            'subscriptions/remove',
            param,
            null,
            'UspesnoOdstranjenaNarocnina',
            'ErrNastavitevPrivzeteVrednosti')
        }).catch((err) => {
          err = null
        })
      },
      UspesnoOdstranjenaNarocnina () {
        this.activeName = '0'
        let paramObvestilo = {}
        paramObvestilo.message = 'Uspešno odstranjena naročnina.'
        this.ShowSuccessMessage(paramObvestilo)
        this.$emit('osveziVsePodatke')
      },
      ErrNastavitevPrivzeteVrednosti (err) {
        let paramObvestilo = {}
        paramObvestilo.message = 'Prišlo je do napake: ' + ' ( ' + err.message + ')'
        this.ShowWarningMessage(paramObvestilo)
      }
    }
  }
</script>
<style scoped src="../../../../../../static/css/moj_profil/narocnine.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mojprofil/DodajanjeNarocnin/MojeNarocnine.vue